import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";

const NavItem = props => {
  const { to, icon, text, type, collapsed } = props;
  const Icon = icon;
  const location = useLocation();
  const isActive =
    location.pathname === to || location.pathname.startsWith(`${to}/`);

  return (
    <Link
      to={to}
      title={collapsed ? text : undefined}
      className={`flex gap-2 items-center rounded-sm leading-tight transition-all duration-300 text-white text-xs relative before:content-[''] before:absolute before:left-0 before:top-0 before:w-[3px] before:h-full before:bg-red-500 before:opacity-0 ${
        collapsed ? "py-[8px] px-[12px] justify-center" : "py-[8px] px-[16px]"
      } ${
        isActive
          ? "bg-white/10 before:opacity-100"
          : `hover:bg-white/10 hover:text-white ${
              type === "logout" && "hover:bg-white/10"
            }`
      }`}
    >
      <Icon className="size-4 shrink-0" />
      {!collapsed && <span className="truncate">{text}</span>}
    </Link>
  );
};

NavItem.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
  collapsed: PropTypes.bool,
};

export default NavItem;
